'use es6';

import { DragSource } from 'react-dnd';
import { pick } from 'underscore';
import { FINDER_BULK_MOVE, FINDER_FOLDER_MOVE_FILE } from 'DesignData/actions/ActionTypes';
import { FINDER_FILE } from 'DesignData/enums/DragDropItemTypes';
export const fileDragSource = DragSource(FINDER_FILE, {
  canDrag(props) {
    const {
      bulkPermissions,
      filePermissions,
      isMultiSelected
    } = props;
    return isMultiSelected ? bulkPermissions[FINDER_BULK_MOVE] : filePermissions[FINDER_FOLDER_MOVE_FILE];
  },

  beginDrag(props) {
    return pick(props, ['file', 'fileId', 'fileType', 'isMultiSelected', 'isSelected', 'parentFolderId', 'canDragIntoLayout', 'catalogWidget']);
  }

}, (connect, monitor) => ({
  canDrag: monitor.canDrag(),
  connectDragPreview: connect.dragPreview(),
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
}));